/**
 * 这个方法主要处理不在 CdnConfigContextProvider 包裹中的页面组件，比如：
 * 1. 404
 * 2. 503
 * 3. drawer dialog等插入在html中的组件
 */

import { switchDomain } from '@weee-fe/module';
import { getCookie } from '../cookie';

const switchImageDomain = (url: string) => {
  const assetCdn = getCookie('assets_cdn') ? JSON.parse(getCookie('assets_cdn')) : null;
  return switchDomain(url, assetCdn);
};

export default switchImageDomain;
